import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Api from "../Api/Api.json";

const fetchEducationTextData = async (topic) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.RECOMMENDATIONS_TEXT_API;
  const requestData = {
    task: "getEducationTextForApp",
    app:"semionhealth",
    topic: topic
  };
  
  console.log('Education API Request:', {
    url: url,
    requestData: requestData,
    topic: topic
  });
  
  try {
    const response = await axios.post(url, requestData, headers);
    
    console.log('Education API Response:', {
      status: response.status,
      statusText: response.statusText,
      data: response.data,
      headers: response.headers
    });

    
    if (!response.data) {
      throw new Error("Network response was not ok - no data received");
    }
    
    return response.data;
  } catch (error) {
    console.error('Education API Error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      topic: topic
    });
    throw error;
  }
};

export const useEducationTextData = (topic) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["educationTextData", topic], // Unique key for this query
    queryFn: () => fetchEducationTextData(topic), // Function to fetch data
    enabled: !!topic, // Only run query if topic is provided
    staleTime: 1000 * 60 * 60 * 6, // Data is considered fresh for 6 hour
    cacheTime: 1000 * 60 * 60 * 6, // Cache data for 6 hour
  });
};
